import { z } from 'zod';
import { OrganType } from '@/api/apis/case';
import { OcsConsoleStatus } from '@/api/apis/resources';
import { TMDXFile } from '@/api/apis/files';
import { NewOcsConsoleForm } from './types';

export const DEFAULT_OCS_CONSOLE_VALUES: NewOcsConsoleForm = {
  ocsConsoleName: '',
  serialNumber: '',
  caseId: '',
  caseName: '',
  nopHub: '',
  organType: OrganType.Heart,
  status: undefined,
  isInMaintenance: false,
  trialProgramId: '',
};

export const ocsConsoleSchema = z.object({
  ocsConsoleName: z.string().min(1).max(30, 'Maximum length: up to 30 symbols'),
  serialNumber: z.string().min(12),
  caseId: z.string().nullable(),
  caseName: z.string().nullable(),
  nopHub: z.uuid({ error: 'Provide hub' }),
  organType: z.enum(OrganType, { error: 'Select Organ Type' }),
  status: z.enum(OcsConsoleStatus, { error: 'Select Status' }).optional(),
  isInMaintenance: z.boolean(),
  image: z.custom<TMDXFile>().optional(),
  logoPath: z.string().optional(),
  trialProgramId: z.string().nullable(),
});

export const ocsConsoleFormSchema = ocsConsoleSchema;
